// Step4EventTheme.tsx
import React from 'react';

interface Step3EventThemeProps {
  eventTheme: string;
  setEventTheme: (theme: string) => void;
  errors: { [key: string]: string };
}

const Step4EventTheme: React.FC<Step3EventThemeProps> = ({ eventTheme, setEventTheme, errors }) => {
  const themes = [
    { id: 'basic', title: '기본', description: '크릿스토어 상품 등록' },
    { id: 'halloween', title: '할로윈', description: '2024년 10월 31일까지 진행되는 테마입니다.' },
  ];

  const handleCheckboxChange = (themeId: string) => {
    if (eventTheme === themeId) {
      // 이미 선택된 테마를 다시 클릭하면 선택 해제
      setEventTheme('');
    } else {
      setEventTheme(themeId);
    }
  };

  return (
    <div className="w-full px-4">
      <label className="block text-left mb-4 text-lg font-semibold">테마 선택</label>
      <div className="flex flex-col gap-4">
        {themes.map((theme) => (
          <label key={theme.id} className="flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={eventTheme === theme.id}
              onChange={() => handleCheckboxChange(theme.id)}
              className="form-checkbox h-5 w-5 text-blue-600"
            />
            <div className="ml-3">
              <span className="font-medium">{theme.title}</span>
              <p className="text-sm text-gray-500">{theme.description}</p>
            </div>
          </label>
        ))}
      </div>
      {errors.eventTheme && <p className="text-red-500 text-sm mt-2">{errors.eventTheme}</p>}
    </div>
  );
};

export default Step4EventTheme;
